import React from "react"

import { RoomMultiSelectSidebar } from "pages/project-page/sidebar/multi/room/RoomMultiSelectSidebar"
import {
  UseRoomMultiSelectSidebarModelArgs,
  useRoomMultiSelectSidebarModel
} from "pages/project-page/sidebar/multi/room/hooks/useRoomMultiSelectSidebarModel"

export const SharedProjectPageRoomMultiSelectSidebarConnector = React.memo(
  (props: UseRoomMultiSelectSidebarModelArgs) => (
    <RoomMultiSelectSidebar
      {...useRoomMultiSelectSidebarModel({ ...props, isShared: true })}
      hidePrice
      hideControls
    />
  )
)
